import FJSubtitleSetting from './FJSubtitleSetting';
import { useDispatch, useSelector } from 'react-redux';
import { setSliceSubtitleSettingActive, setSliceSubtitleStyle } from '../../../redux/slices/FJSliceTextToVideo';
import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';

const FJSubtitleSettingContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const subtitleSettingActive = useSelector(state => state.textToVideo.subtitleSettingActive);
    const subtitleStyle = useSelector(state => state.textToVideo.subtitleStyle);
    const onSubtitleSettingActiveChange = useCallback(
        active => {
            dispatch(setSliceSubtitleSettingActive(active));
        },
        [dispatch],
    );
    const subtitleStyleChange = useCallback(
        item => {
            dispatch(setSliceSubtitleStyle(item));
        },
        [dispatch],
    );
    return (
        <FJSubtitleSetting
            subtitleSettingActive={subtitleSettingActive}
            onSubtitleSettingActiveChange={onSubtitleSettingActiveChange}
            subtitleStyle={subtitleStyle}
            subtitleStyleChange={subtitleStyleChange}
        />
    );
};

export default FJSubtitleSettingContainer;
